import { faArrowRight } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Image from 'next/image'
import styles from './LandingPageHeader.module.scss'

export default function LandingPageHeader({ ctaLabel = 'integrityxd.com', ctaHref = 'https://integrityxd.com', logos = {} }) {
  const integrity = logos.integrity ?? { src: '/IntegrityTitleLogo.svg', alt: 'IntegrityXD' }
  const motech = logos.motech ?? { src: '/MotivationLogoBrand.svg', alt: 'Motivation Technologies' }

  return (
    <header className={styles.header}>
      <div className={styles.logos}>
        <Image
          className={`${styles.logo} ${styles.logoIntegrity}`}
          src={integrity.src}
          alt={integrity.alt}
          width={150}
          height={44}
          priority
        />
        <Image className={`${styles.logo} ${styles.logoMotech}`} src={motech.src} alt={motech.alt} width={150} height={44} priority />
      </div>

      <a className={styles.cta} href={ctaHref}>
        <span>{ctaLabel}</span>
        <FontAwesomeIcon icon={faArrowRight} />
      </a>
    </header>
  )
}
